var swatchSwiper = new Swiper(".variant-input-swiper", {
  slidesPerView: 3.2,
  spaceBetween: 8,
  navigation: {
    nextEl: ".variant-slider-arrow-next",
    prevEl: ".variant-slider-arrow-prev",
  },
  breakpoints: {
    480: {
      slidesPerView: 4,
      spaceBetween: 8,
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    1500: {
      slidesPerView: 4,
      spaceBetween: 8,
    }
  }
});
